import { useQuery } from "@tanstack/vue-query";
import { httpClientOmni } from "@/libraries";
import { computed } from "vue";

/**
 * Composable for getting user role information
 * This centralizes the QUERY_GET_ROLE query to avoid duplication
 * and ensures consistent behavior across the app
 */
export default function useRole() {
  // Shared query - will be cached and reused across components
  const { data: role } = useQuery({
    queryKey: ["QUERY_GET_ROLE"],
    queryFn: async () => {
      const slugAgents = ["staff", "new-agent", "agent"];
      const response = await httpClientOmni.get("v3/accessibility/get-role");
      const isAgent = slugAgents.includes(response.data.slug);
      const isAdmin = !isAgent;
      return {
        rawData: response.data,
        isAgent,
        isAdmin,
      };
    },
    staleTime: Infinity, // Cache forever since role doesn't change during session
  });

  // Computed properties for convenient access
  const isAgent = computed(() => role.value?.isAgent ?? false);
  const isAdmin = computed(() => role.value?.isAdmin ?? false);

  return {
    role, // Raw role data (reactive)
    isAgent, // Computed: true if user is an agent
    isAdmin, // Computed: true if user is an administrator
  };
}
